import styled from 'styled-components';
import { Card } from 'antd';
import { onPhone } from '../theme/tokens';

const Wrap = styled.div`
  display: grid;
  place-items: center;
  min-height: 100dvh;
  padding: 16px;
  background: var(--brand-grad);

  .auth-foot {
    text-align: center;
    margin-top: 16px;
  }
  ${onPhone} {
    .auth-foot a {
      display: inline-block;
      padding: 12px 8px;
    }
  }
`;

const CARD = { width: '100%', maxWidth: 400, borderRadius: 14, boxShadow: '0 12px 40px rgba(0,0,0,0.3)' };

export default function AuthCard({ foot, children }) {
  return (
    <Wrap>
      <Card style={CARD} bordered={false}>
        {children}
        {foot && <div className="auth-foot">{foot}</div>}
      </Card>
    </Wrap>
  );
}
